<template>
  <el-tooltip placement="right" :disabled="$config.googleAuth">
    <template slot="content">
      <b>{{ $t("feature-disabled") }}</b>
      <span class="d-block">{{ $t("feature-currently-unavailable") }}</span>
    </template>
    <button
      :disabled="!$config.googleAuth"
      type="button"
      class="btn btn-neutral btn-icon"
      @click="$emit('handleLogin')"
    >
      <span class="btn-inner--icon"
        ><img src="~/static/img/icons/common/google.svg" alt=""
      /></span>
      <span class="btn-inner--text">{{ $t("google") }}</span>
    </button>
  </el-tooltip>
</template>

<script>
export default {
  name: "LoginWithGoogle"
};
</script>
